import { gql } from "@apollo/client"
import {
  Company,
  CompanyEngagementsArgs,
  ContractBilling,
  EngagementState,
  QueryCompanyArgs,
} from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

const QUERY = gql`
  query PayrollChangePopupGetCompanyEngagements(
    $companyId: ID!
    $contractorsBillingTypes: [ContractBilling!]
    $states: [EngagementState!]
    $query: String
  ) {
    company(companyId: $companyId) {
      id

      engagements(
        query: $query
        contractorsBillingTypes: $contractorsBillingTypes
        states: $states
      ) {
        collection {
          id
          state
          engagementType
          isPayrollTeamMember
          name
          cutoffMonthDay
          nextCutoffTime
          employment {
            id
            name
            salaryCurrencyCode
            salaryAmount
            cutoffMonthDay
            terminationDate
            startDate
            __typename
          }
          contract {
            id
            name
            salaryCurrencyCode
            salary
            terminationDate
            startDate
            __typename
          }
        }
      }
    }
  }
`

export const useGetCompanyEngagements = (variables: QueryCompanyArgs & CompanyEngagementsArgs) =>
  useQuery<{ company: Pick<Company, "engagements"> }, QueryCompanyArgs & CompanyEngagementsArgs>(
    QUERY,
    {
      variables: {
        ...variables,
        contractorsBillingTypes: [ContractBilling.Fixed],
        states: [EngagementState.Engaged],
      },
    },
  )
